import { TmBaseError } from '@/core/error/tmBaseError'

export class TmComponentError extends TmBaseError {
  public name = 'TmComponentError'
}
